export default __webpack_public_path__ + "static/media/CH.68539527.svg";